import axios from '../../../../api/axios';
import React, {useState,useEffect} from 'react'
import {EyeFill,PencilFill,Trash3Fill,PersonPlus} from "react-bootstrap-icons"
import { useNavigate,useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import loadingIcon from '../../../../Images/loading.gif'
import { isEmpty } from '../../../../Utilities/Utils';
import { useAuth } from '../../../../ContextApp/AuthContext';
import './courscss.css'
function Classe() {
    const {user}=useAuth()
    const [cours_enseignes,setCours_enseignes]=useState([])
    const [curentpage,setCurentpage]=useState(1)
    const [search,setSearch]=useState('')
    const [my_classe,setMy_classe]=useState("")
        const [classes,setClasses]=useState([])


    const [recordperpage,setRecordperpage]=useState(50)
    let navigate=useNavigate()
    const lastIndex=curentpage * recordperpage
    const firstIndex=lastIndex - recordperpage
    const {id}=useParams()
   // const records= search.toLowerCase() === '' && my_classe==='' ? cours_enseignes.slice(firstIndex, lastIndex) : cours_enseignes.filter((cours_enseigne)=>{return search.toLowerCase() === '' && my_classe==='' ? cours_enseigne : isEmpty(my_classe) ? cours_enseigne.cours.includes(search) || !isEmpty(cours_enseigne.enseignant) && cours_enseigne.enseignant.includes(search) : cours_enseigne.cours.includes(search)  && cours_enseigne.idclasse==my_classe || !isEmpty(cours_enseigne.enseignant) && cours_enseigne.enseignant.toLowerCase().includes(search)}).slice(firstIndex, lastIndex)
   const records=search.toLowerCase()==="" && my_classe==="" ? cours_enseignes.filter((cours_enseign)=>cours_enseign.enseigner!="non").slice(firstIndex, lastIndex) : !isEmpty(search) && !isEmpty(my_classe) ? cours_enseignes.filter((cours_enseign)=>cours_enseign.cours.includes(search.toLowerCase()) || cours_enseign.enseignant.includes(search.toLowerCase())  && cours_enseign.idclasse==my_classe && cours_enseign.enseigner!="non") : !isEmpty(search) && isEmpty(my_classe) ? cours_enseignes.filter((cours_enseign)=>cours_enseign.cours.includes(search.toLowerCase()) || cours_enseign.enseignant.includes(search) && cours_enseign.enseigner!="non"):isEmpty(search) && !isEmpty(my_classe) && cours_enseignes.filter((cours_enseign)=>cours_enseign.idclasse==my_classe && cours_enseign.enseigner!="non").slice(firstIndex, lastIndex) 

   const recordNpage=search.toLowerCase()==="" && my_classe==="" ? cours_enseignes.filter((cours_enseign)=>cours_enseign.enseigner!="non"): !isEmpty(search) && !isEmpty(my_classe) ? cours_enseignes.filter((cours_enseign)=>cours_enseign.cours.includes(search.toLowerCase()) || cours_enseign.enseignant.includes(search.toLowerCase())  && cours_enseign.idclasse==my_classe && cours_enseign.enseigner!="non") : !isEmpty(search) && isEmpty(my_classe) ? cours_enseignes.filter((cours_enseign)=>cours_enseign.cours.includes(search.toLowerCase()) || cours_enseign.enseignant.includes(search) && cours_enseign.enseigner!="non"):isEmpty(search) && !isEmpty(my_classe) && cours_enseignes.filter((cours_enseign)=>cours_enseign.idclasse==my_classe && cours_enseign.enseigner!="non")

    const npage=Math.ceil(recordNpage.length/recordperpage)
    const numbers=[...Array(npage+1).keys()].slice(1)      
   //const recordperpage=2
    
    //const numbers=[1,2,3,4,5]
    const [loading,setLoading]=useState(false)
    

    useEffect(
        ()=>{
                Classes_initialesRequest()
                handle_classe_request()
        },[])
    const Classes_initialesRequest=async ()=>{
        await axios.post('api/getcours',{idecole:user?.ecole?.id,annee_scolaire:user?.programme_scolaire?.annee_scolaire}).then(
            (res)=>{
                setCours_enseignes(res.data.items)
                setLoading(false)
              
            }
        ).catch((err)=>{
           
        })
    }
    const handle_classe_request=async()=>{
        try{
            await axios.post('api/classes_getter',{idecole:user?.ecole?.id}).then((res)=>{

                setClasses(res.data.items)
            })
        }
        catch(e){

        }
    }
 /*   
    const Iteration=()=>{
        return loading ? (
            <div className='w-100 mx-auto'>
                <img src={loadingIcon} alt='loading'/>
            </div>
        ) : (
            
                records.filter((cours_enseigne)=>{
                    return search.toLowerCase()==="" && my_classe==="" ? cours_enseignes: !isEmpty(search) && !isEmpty(my_classe) ? cours_enseignes.filter((cours_enseign)=>cours_enseign.cours.includes(search.toLowerCase())  && cours_enseign.idclasse==my_classe|| cours_enseign.enseignant.includes(search.toLowerCase()) && cours_enseign.enseigner!="non") : !isEmpty(search) && isEmpty(my_classe) ? cours_enseignes.filter((cours_enseign)=>cours_enseign.cours.includes(search.toLowerCase()) || cours_enseign.enseignant.includes(search) && cours_enseign.enseigner!="non"):isEmpty(search) && !isEmpty(my_classe) && cours_enseignes.filter((cours_enseign)=>cours_enseign.idclasse==my_classe && cours_enseign.enseigner!="non")
                }).map((cours_enseigne,indexV)=>
                {
                  return(
                        <tr key={indexV} className='ligne'>
                            <td className='sticky-col'>{indexV+1}</td>
                            <td className='sticky-col'>{cours_enseigne.cours.toLowerCase()}</td>
                            <td>{cours_enseigne.my_classe}</td>
                            <td>{cours_enseigne.ponderation}</td>
                            <td>{cours_enseigne.enseignant}</td>
                            <td><Trash3Fill color='brown' size={20} className='d-inline-flex mx-2 icone' onClick={()=>AlertNotification(cours_enseigne.id)} />{!isEmpty(cours_enseigne.enseignant) &&<PencilFill color="royalblue" size={20} className='d-inline-flex mx-2 icone' onClick={()=>navigate(`${cours_enseigne.id}`)}/>}   </td>
                        </tr>
                  )
                    
                }
                )
            
        )
        
            }   */
const Iteration = () => {
    // 1. État de chargement moderne
    if (loading) {
        return (
            <tr>
                <td colSpan="6" className="text-center py-5">
                    <div className="spinner-border text-primary me-2" role="status"></div>
                    <span className="text-muted fw-light">Chargement des cours...</span>
                </td>
            </tr>
        );
    }

    // 2. Logique de filtrage simplifiée et lisible
    const filteredData = records.filter((item) => {
        const matchesSearch = search === "" || 
            item.cours.toLowerCase().includes(search.toLowerCase()) || 
            item.enseignant.toLowerCase().includes(search.toLowerCase());
        
        const matchesClasse = my_classe === "" || item.idclasse == my_classe;

        return matchesSearch && matchesClasse && item.enseigner !== "non";
    });

    // 3. Gestion du cas "Aucun résultat"
    if (filteredData.length === 0) {
        return (
            <tr>
                <td colSpan="6" className="text-center py-5 text-muted italic">
                    <i className="bi bi-search me-2"></i> Aucun cours ne correspond à vos critères.
                </td>
            </tr>
        );
    }

    // 4. Rendu des lignes
    return filteredData.map((cours, index) => (
        <tr key={cours.id || index} className="align-middle">
            <td className="ps-4 text-muted small">{index + 1}</td>
            
            {/* Colonne Cours avec style distinct */}
            <td>
                <div className="fw-bold text-dark text-capitalize">{cours.cours.toLowerCase()}</div>
            </td>
             {/* Colonne Cours avec style distinct */}
            <td>
                <div className="fw-bold text-dark text-capitalize">{cours?.categorie?.toLowerCase()}</div>
            </td>

            {/* Badge pour la classe */}
            <td>
                <span className="badge bg-light text-primary border border-primary-subtle px-3 rounded-pill">
                    {cours.my_classe}
                </span>
            </td>

            {/* Pondération mise en avant */}
            <td>
                <div className="fw-semibold text-secondary">
                    {cours.ponderation} <small className="fw-light">pts</small>
                </div>
            </td>

            {/* Enseignant avec icône */}
            <td>
                <div className="d-flex align-items-center">
                    <div className="bg-soft-primary rounded-circle p-1 me-2 text-center" style={{width: '24px', height: '24px', fontSize: '12px'}}>
                        <i className="bi bi-person-fill text-primary"></i>
                    </div>
                    <span className="small">{cours.enseignant}</span>
                </div>
            </td>

            {/* Actions avec boutons stylisés */}
            <td className="text-end pe-4">
                <div className="btn-group shadow-sm border rounded-3 overflow-hidden">
                    <button 
                        className="btn btn-white btn-sm px-3 border-0 border-end" 
                        onClick={() => navigate(`${cours.id}`)}
                        title="Modifier"
                    >
                        <PencilFill color="royalblue" size={14} />
                    </button>
                    <button 
                        className="btn btn-white btn-sm px-3 border-0 text-danger" 
                        onClick={() => AlertNotification(cours.id)}
                        title="Supprimer"
                    >
                        <Trash3Fill size={14} />
                    </button>
                </div>
            </td>
        </tr>
    ));
};

            function AlertNotification(idcours_enseigne){
                Swal.fire({
                    title:'Etes-vous sûr de le supprimer ?',
                    text:'Ce cours sera supprimé',
                    icon:'warning',
                    showDenyButton:true,
                    showCancelButton:true,
                    confirmButtonText:'Confirmer',
                    denyButtonText:'Annuler'
                }).then((resultat)=>{
                    if(resultat.isConfirmed){
                        navigate(`/Cours/delete/${idcours_enseigne}`)
                            }
                })
            }
    return(
        <>
      <div className="container-fluid py-4 px-3">
    {/* En-tête avec Carte de Contrôle */}
    <div className="card border-0 shadow-sm mb-4 rounded-4">
        <div className="card-body p-4">
            <div className="row g-3 align-items-center">
                {/* Titre et Stats */}
                <div className="col-12 col-xl-4 text-center text-xl-start">
                    <h4 className="fw-bold mb-1 text-dark">Gestion des Cours</h4>
                    <p className="text-muted small mb-0">
                        Total : <span className="badge bg-primary rounded-pill">{records.length} cours</span>
                    </p>
                </div>

                {/* Bouton Ajouter */}
                <div className="col-12 col-md-4 col-xl-2">
                    <button 
                        onClick={() => navigate('insertion')} 
                        className="btn btn-success w-100 shadow-sm d-flex align-items-center justify-content-center py-2"
                    >
                        <PersonPlus className="me-2" size={20} /> 
                        <span>Dispatcher</span>
                    </button>
                </div>

                {/* Barre de Recherche */}
                <div className="col-12 col-md-4 col-xl-3">
                    <div className="input-group">
                        <span className="input-group-text bg-white border-end-0 text-muted">
                            <i className="bi bi-search"></i>
                        </span>
                        <input 
                            type="text" 
                            className="form-control border-start-0 ps-0 shadow-none" 
                            placeholder="Rechercher un cours..." 
                            onChange={(e) => setSearch(e.target.value.toLowerCase())} 
                            value={search} 
                        />
                    </div>
                </div>

                {/* Filtre par Classe */}
                <div className="col-12 col-md-4 col-xl-3">
                    <div className="input-group">
                        <span className="input-group-text bg-white border-end-0 text-muted">
                            <i className="bi bi-filter"></i>
                        </span>
                        <select 
                            className="form-select border-start-0 ps-0 shadow-none fw-semibold" 
                            onChange={(e) => setMy_classe(e.target.value)} 
                            value={my_classe}
                        >
                            <option value="">Toutes les classes</option>
                            {classes.map((cla) => (
                                <option value={cla.id} key={cla.id}>{cla.nom}</option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>
        </div>
    </div>

    {/* Table des Matières */}
    <div className="card border-0 shadow-sm rounded-4 overflow-hidden">
        <div className="table-responsive">
            <table className="table table-hover align-middle mb-0">
                <thead className="bg-light border-bottom">
                    <tr className="text-secondary small text-uppercase fw-bold">
                        <th className="ps-4 py-3">#</th>
                        <th>Cours</th>
                        <th>Catégorie</th>
                        <th>Classe</th>
                        <th>Pondération</th>
                        <th>Enseignant</th>
                        <th className="text-end pe-4">Action</th>
                    </tr>
                </thead>
                <tbody className="border-top-0">
                    {Iteration()}
                </tbody>
            </table>
        </div>
    </div>

    {/* Pagination Modernisée */}
    <div className="d-flex flex-wrap justify-content-between align-items-center mt-4 bg-white p-3 rounded-4 shadow-sm">
        <div className="d-flex align-items-center mb-3 mb-md-0">
            <span className="small text-muted me-2">Afficher</span>
            <input 
                type="number" 
                className="form-control form-control-sm text-center fw-bold shadow-none" 
                style={{ width: '60px' }}
                value={recordperpage} 
                onChange={(e) => setRecordperpage(e.target.value || 1)} 
                onBlur={() => setCurentpage(1)} 
            />
            <span className="small text-muted ms-2">par page</span>
        </div>

        <nav>
            <ul className="pagination pagination-sm mb-0">
                <li className="page-item">
                    <button className="page-link rounded-start-pill px-3" onClick={Prepage}>Précédent</button>
                </li>
                {numbers.map((number, index) => (
                    <li className={`page-item ${curentpage === number ? 'active' : ''}`} key={index}>
                        <button className="page-link px-3" onClick={() => changeCPage(number)}>{number}</button>
                    </li>
                ))}
                <li className="page-item">
                    <button className="page-link rounded-end-pill px-3" onClick={Nextpage}>Suivant</button>
                </li>
            </ul>
        </nav>
    </div>
</div>

        </>
    )
function Prepage(){
    if(curentpage > 1){
        setCurentpage(curentpage-1)
    }
}
function changeCPage(id){
   setCurentpage(id)
}
function Nextpage(){
    if(curentpage < npage){
       // alert(curentpage)
        setCurentpage(curentpage+1)
    }
}

}
export default Classe

